import {Component} from 'react';
import h from 'react-hyperscript';
import './SurveyStats.scss';
import {eyebrow, subhead} from 'Components/Typography/Typography';
import {formatDateMicro} from 'Src/utils/utils';

class SurveyStats extends Component {
  get daysLabel() {
    return this.props.daysLeft === 1 ? 'day': 'days';
  }

  render() {
    const shortDate = formatDateMicro(this.props.expirationDate);
    return (
      h('div', {
        className: 'col-ratio-1 report-overview__sidebar',
      }, [
        h(eyebrow, null, 'Report Locked In'),

        h('div', {className: 'padding-bottom--md'},
            h(subhead, {
              className: 'flex',
            }, [
              h('span', {
                className: 'material-icons padding-right--micro',
              }, 'access_time'),
              `${this.props.daysLeft} ${this.daysLabel} (${shortDate})`,
            ])
        ),

        h(eyebrow, null, 'Survey Respondents'),

        h('div', {
          className: 'padding-bottom--md',
        },
        h(subhead, {
          className: 'flex',
        }, [
          h('span', {
            className: 'material-icons padding-right--micro',
          }, 'person'),
          this.props.respondents,
        ])
        ),
      ])
    );
  }
}

export default SurveyStats;
